module.exports = __webpack_public_path__ + "media/images/already-read-label@3x-3bd2afa837732f384bd8b3d171f863ed.png";